document.addEventListener('DOMContentLoaded', () => {
    const toggleButton = document.getElementById('toggle-menu');
    const mainMenu = document.getElementById('main-menu');
    const bodyOverlay = document.getElementById('body-overlay-bg');
    const menuLabel = toggleButton.querySelector('.label');
    
    let isMenuOpen = false;

    const toggleMenu = () => {
        isMenuOpen = !isMenuOpen;
        toggleButton.setAttribute('aria-expanded', isMenuOpen);
        mainMenu.setAttribute('aria-hidden', !isMenuOpen);
        toggleButton.classList.toggle('is-active');
        document.body.classList.toggle('menu-is-open');


        if (!isMenuOpen) {
            document.querySelectorAll('.menu-item-has-children').forEach(item => {
                item.classList.remove('submenu-active');
            });
        }
    };


    const parentItems = document.querySelectorAll('li.menu-item-has-children');
    

    parentItems.forEach(parentItem => {
        parentItem.classList.add('submenu-active');
        const link = parentItem.querySelector('a');
        
        link.addEventListener('click', (e) => {
            e.preventDefault();
            
         
            parentItems.forEach(item => {
                if (item !== parentItem) {
                    item.classList.remove('submenu-active');
                }
            });

   
            parentItem.classList.toggle('submenu-active');
        });
    });

 
    toggleButton.addEventListener('click', toggleMenu);
    bodyOverlay.addEventListener('click', () => {
        if (isMenuOpen) toggleMenu();
    });

    // Close menu on escape key
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && isMenuOpen) toggleMenu();
    });
});